"use strict";var u=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var e=(s,l,o,i)=>{for(var t=i>1?void 0:i?h(l,o):l,a=s.length-1,n;a>=0;a--)(n=s[a])&&(t=(i?n(l,o,t):n(t))||t);return i&&t&&u(l,o,t),t};import{baseStyles as m,CiscoUElement as b,html as c,nothing as p}from"@cisco-u/base";import{property as r}from"@cisco-u/base/src/decorators.js";import y from"./bookmark.css.js";import"@cisco-u/icons/icons/cu-icon-bookmark.js";import"@cisco-u/tooltip/cu-tooltip.js";export class Bookmark extends b{constructor(){super(...arguments);this.displayOnly=!1}static get styles(){return[m,y]}render(){return this._returnBookmark()}_returnBookmark(){return this.displayOnly?c`
        <cu-tooltip
          text="${this.class=="active"?"Remove":this.label}"
          anchoredRight=${this.forCard?"true":p}
        >
          <span
            aria-label="${this.label}"
            class="ellipse ${this.class}"
            part="bookmark"
          >
            <cu-icon-bookmark part="iconSize"></cu-icon-bookmark>
          </span>
        </cu-tooltip>
      `:c`
      <cu-tooltip
        text="${this.class=="active"?"Remove":this.label}"
        anchoredRight=${this.forCard?"true":p}
      >
        <button
          aria-label="${this.label}"
          class="ellipse ${this.class}"
          part="bookmark"
        >
          <cu-icon-bookmark part="iconSize"></cu-icon-bookmark>
        </button>
      </cu-tooltip>
    `}}e([r({type:String,reflect:!0})],Bookmark.prototype,"class",2),e([r({type:String,reflect:!0})],Bookmark.prototype,"height",2),e([r({type:String,reflect:!0})],Bookmark.prototype,"width",2),e([r({type:String,reflect:!0})],Bookmark.prototype,"label",2),e([r({type:Boolean,reflect:!0})],Bookmark.prototype,"forCard",2),e([r({type:Boolean,reflect:!0})],Bookmark.prototype,"displayOnly",2);
//# sourceMappingURL=Bookmark.js.map
